<div class="col-12">
  <div class="col-12">
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="csvExport">
      {{ $t('message.file_export') }}
    </b-button>
  </div>
  <div class="col-12">
    <custom-table class="mt-2 ml-2" type="simple" useSort useStripeStyle rowSelect hasTabs currentSortkey="dtc"
      initSortDir="asc" :items="measuredDataItems" :columns="measuredDataColumns">
    </custom-table>
  </div>
  <processing-view :processing="processing"></processing-view>
</div>